<template>
  <v-card class="pa-4">
    <v-flex xs12 pb-4 v-if="err">
      <v-alert :value="true" type="error">{{err}}</v-alert>
    </v-flex>
    <v-flex xs12 pb-4 v-if="success">
      <v-alert :value="true" type="success">{{success}}</v-alert>
    </v-flex>
    <p>{{$lang.labels.licenseActivationText}}</p>
    <v-layout row wrap justify-space-between>
      <v-btn flat @click="$emit('close')" class="mx-0">{{$lang.actions.no}}</v-btn>
      <v-btn color="primary" @click="activate()" class="mx-0" :disabled="activating">{{$lang.actions.yes}}</v-btn>
    </v-layout>
  </v-card>
</template>

<script>
  export default {
    props: ['licenseId'],
    data: () => ({
      err: '',
      success: '',
      activating: false,
    }),
    methods: {
      activate() {
        this.activating = true;
        this.$http.post(`license/activate/${this.licenseId}`)
          .then((res) => {
            if (res.body.status === 'Success') {
              this.success = 'License activated successfuly'
              setTimeout(() => {
                this.success = '';
                this.$emit('close');
                this.activating = true;
              }, 3000);
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.activating = false;
            this.err = err.body.statusText || err.body.message;
          });
        }
    },
  };
</script>


// WEBPACK FOOTER //
// LicenseActivationModal.vue?6b7f6efd